<template>
  <div class="checkbox-label-container">
    <UserAvatar
      style="width: 20px;height: 20px;margin-right: 12px"
      :user-avatar="value.avatar"
    />
    <div
      v-if="value.searchType"
      class="mobile-container"
    >
      <div class="name">{{ value.name }}</div>
      <div class="mobile">{{ value.mobile }}</div>
    </div>
    <template v-else>
      <span class="userName">{{ value.name }}</span>
      <DeviceType :deviceType="value.deviceType" :roomId="value.roomId" />
    </template>
  </div>
</template>

<script>
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
import DeviceType from '@/components/business/DeviceType'

export default {
  name: 'CheckboxLabel',
  components: { UserAvatar, DeviceType },
  props: {
    value: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.userName{
  vertical-align: middle;
  display: inline-block;
  line-height: 20px;
}
::v-deep .svg-icon {
  width: 20px;
  height: 20px;
}
</style>
